import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for VoiceCallIndicator component customisation
 * Returns styling for the voice call sticky banner
 */
export const useVoiceCallIndicatorCustomisation = () => {
  const { getField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_CALL,
    sectionKey: PUI.CHATBOT_CALL_SECTION_KEYS.CALL_STICKY_BANNER,
    blockKey: PUI.CHATBOT_CALL_BLOCK_KEYS.CALL_STICKY_BANNER,
  });

  const iconColor = getField(PUI.COMMON_FIELD_KEYS.ICON);
  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const endCallIconColor = getField(PUI.COMMON_FIELD_KEYS.END_CALL_ICON_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);

  return {
    iconColor,
    textContent,
    textColor,
    endCallIconColor,
    backgroundColor,
    borderColor,
  };
};
